import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconSettingClass from '../../../../../../components/settingsIcon';
import EarningCodes from './earningCodes';
import EmployerSettings from './employer';
import CostCenter from './costCenter';
import ReportSettings from './reportSettings';
import EmployeeSettings from './employee';
import { getCertifiedSettings, saveCertifiedSettings } from '../../../../../../store/actions';
import { isEmpty, isEqual } from 'lodash';

const CertifiedPayrollReportSettings = props => {
    const [CPSettings, setCPSettings] = useState({});
    const [mappedEarningCodes, setMappedEC] = useState([]);
    const [NPSRateTableId, setNPSRateTableId] = useState("");
    const [GenRateTableId, setGenRateTableId] = useState("");
    const [BillingRateTableId, setBillingRateTableId] = useState("");
    const [compHistoryReportId, setCompHistoryReportId] = useState("");
    const [tableTemplate, setTemplate] = useState([]);
    const [signerName, setSignerName] = useState("");
    const [signerTitle, setTitle] = useState("");
    const [employerEmail, setEmail] = useState("");
    const [employerPhone, setPhone] = useState("");
    const [employerName, setEmployerName] = useState("");
    const [employerAddress, setAddress] = useState("");
    const [contractorName, setContractorName] = useState("");
    const [employerTaxId, setTaxId] = useState("");
    const [jourOrApprenField, setJourField] = useState("");
    const [jourOrApprenDefVal, setJourDefVal] = useState("");
    const [tradeClassSource, setTradeClassSource] = useState("");
    const [tradeClassField, setTradeClassField] = useState("");
    const [defTradeClass, setDefTradeClass] = useState("");
    const [certifiedJobField, setCertifiedJobField] = useState("");
    const [buildingTypeField, setBuildingTypeField] = useState("");
    const [useRetro, setUseRetro] = useState(false);
    const [combineEins, setCombineEins] = useState(false);
    const [costCenterTreeName, setCostCenter] = useState("");
    const [saveEnabled, setEnable] = useState(false);
    const [changesTracker, setChanges] = useState({});
    const [deductBenefitsField, setDeductBenefits] = useState("");
    const [contractRegistrationField, setContractRegField] = useState("");
    const [contractRegDefault, setContractRegDef] = useState("");

    useDeepCompareEffect(() => {
        getSettings(props.ClientDataReducer.companyShortName);
    }, [mappedEarningCodes, CPSettings,]);

    useEffect(() => {
        compareChanges()
    }, [NPSRateTableId,
        GenRateTableId,
        BillingRateTableId,
        compHistoryReportId,
        tableTemplate,
        signerName,
        signerTitle,
        employerName,
        employerAddress,
        contractorName,
        employerTaxId,
        employerEmail,
        employerPhone,
        jourOrApprenField,
        jourOrApprenDefVal,
        tradeClassSource,
        tradeClassField,
        defTradeClass,
        certifiedJobField,
        useRetro,
        combineEins,
        costCenterTreeName,
        deductBenefitsField,
        buildingTypeField,
        contractRegistrationField,
        contractRegDefault
    ]);

    async function getSettings(companyShortName) {
        await props.getCertifiedSettings(companyShortName);
        setCPSettings({ ...props.CertifiedPayrollReducer });
        setNPSRateTableId(CPSettings.NPSRateTableId);
        setGenRateTableId(CPSettings.GenRateTableId);
        setBillingRateTableId(CPSettings.BillingRateTableId);
        setCompHistoryReportId(CPSettings.compHistoryReportId);
        setTemplate(CPSettings.tableTemplate);
        setSignerName(CPSettings.signerName);
        setTitle(CPSettings.signerTitle);
        setEmail(CPSettings.employerEmail);
        setPhone(CPSettings.employerPhone);
        setEmployerName(CPSettings.employerName);
        setAddress(CPSettings.employerAddress);
        setContractorName(CPSettings.contractorName);
        setTaxId(CPSettings.employerTaxId);
        setJourField(CPSettings.jourOrApprenField);
        setJourDefVal(CPSettings.jourOrApprenDefVal);
        setTradeClassSource(CPSettings.tradeClassSource);
        setTradeClassField(CPSettings.tradeClassField);
        setDefTradeClass(CPSettings.defTradeClass);
        setCertifiedJobField(CPSettings.certifiedJobField);
        setUseRetro(CPSettings.useRetro);
        setCombineEins(CPSettings.combineEins);
        setCostCenter(CPSettings.costCenterTreeName);
        setBuildingTypeField(CPSettings.buildingTypeField);
        setDeductBenefits(CPSettings.deductBenefitsField);
        setContractRegField(CPSettings.contractRegistrationField);
        setContractRegDef(CPSettings.contractRegDefault);
        mapCodes();
        compareChanges();
    };

    function compareChanges() {
        let changes = {
            NPSRateTableId,
            GenRateTableId,
            BillingRateTableId,
            compHistoryReportId,
            tableTemplate,
            costCenterTreeName,
            signerName,
            signerTitle,
            employerName,
            employerAddress,
            contractorName,
            employerTaxId,
            employerEmail,
            employerPhone,
            jourOrApprenField,
            jourOrApprenDefVal,
            tradeClassSource,
            tradeClassField,
            defTradeClass,
            certifiedJobField,
            deductBenefitsField,
            useRetro,
            combineEins,
            buildingTypeField,
            contractRegistrationField,
            contractRegDefault,
            earningCodes: mappedEarningCodes.filter(mec => mec.earningType).map(ec => {
                let e = { code: ec._id, earningType: ec.earningType };
                if (ec.ecId) e._id = ec.ecId;
                return e;
            })
        };
        let hasChanges;
        let changesObj = {};
        for (let key in changes) {
            if (!isEqual(changes[key], CPSettings[key])) {
                hasChanges = true;
                changesObj[key] = changes[key];
                if (changesObj.hasOwnProperty(key) && (changesObj[key] === undefined || changesObj[key] === "")) changesObj[key] = null;
            };
        };
        setChanges(changesObj);
        setEnable(hasChanges);
    }

    async function updateSettings() {
        //let earningCodes = mappedEarningCodes.filter(ec => ec.earningType).map(ec => ({ code: ec._id, earningType: ec.earningType }));
        let query = {
            companyId: props.ClientDataReducer.companyId
        };
        let update = changesTracker;
        if (!CPSettings.companyShortName) update.companyShortName = props.ClientDataReducer.companyShortName;
        if (!isEmpty(update)) await props.saveCertifiedSettings({ query, update });
        setCPSettings({ ...props.CertifiedPayrollReducer });
        mapCodes();
    };

    function mapCodes() {
        let mappedEarningCodes = props.EarningCodeReducer.map(ec => {
            let inSettings = CPSettings.earningCodes && CPSettings.earningCodes.find(ecd => ecd.code === ec._id);
            if (inSettings) {
                ec.earningType = inSettings.earningType;
                ec.ecId = inSettings._id;
            };
            return ec;
        });
        setMappedEC(mappedEarningCodes);
    };

    function changeEarningCode() {
        compareChanges()
    }

    function onValueChange(val, field) {
        switch (field) {
            case "NPSRateTable": {
                setNPSRateTableId(val);
                break;
            };
            case "GenRateTable": {
                setGenRateTableId(val);
                break;
            };
            case "BillingRateTable": {
                setBillingRateTableId(val);
                break;
            };
            case "compHistReportId": {
                setCompHistoryReportId(val);
                break;
            };
            case "tableTemplate": {
                setTemplate(val.map(tt => tt.value));
                break;
            };
            case "signerName": {
                setSignerName(val);
                break;
            };
            case "signerTitle": {
                setTitle(val);
                break;
            };
            case "employerName": {
                setEmployerName(val);
                break;
            };
            case "employerAddress": {
                setAddress(val);
                break;
            };
            case "contractorName": {
                setContractorName(val);
                break;
            };
            case "employerTaxId": {
                setTaxId(val);
                break;
            };
            case "email": {
                setEmail(val);
                break;
            };
            case "phone": {
                setPhone(val);
                break;
            };
            case "jourDefault": {
                setJourDefVal(val);
                break;
            }
            case "jourField": {
                setJourField(val);
                break;
            }
            case "tradeClassField": {
                setTradeClassField(val);
                break;
            };
            case "buildingType": {
                setBuildingTypeField(val);
                break;
            };
            case "tradeClassSource": {
                setTradeClassSource(val.value);
                break;
            };
            case "tradeClassDef": {
                setDefTradeClass(val);
                break;
            };
            case "deductBenefits": {
                setDeductBenefits(val);
                break;
            };
            case "isCertified": {
                setCertifiedJobField(val);
                break;
            };
            case "useRetro": {
                setUseRetro(val);
                break;
            };
            case "combineEins": {
                setCombineEins(val);
                break;
            };
            case "costCenterParent": {
                setCostCenter(val.key);
                break;
            };
            case "contractReg": {
                setContractRegField(val);
                break;
            };
            case "contractRegDefault": {
                setContractRegDef(val);
                break;
            };
        };
        compareChanges()
    };


    return (
        <Accordion>
            <AccordionSummary
                expandIcon={<IconSettingClass />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography className="reportTitle">Certified payroll report</Typography>
            </AccordionSummary>

            <AccordionDetails>
                <div className="reportListAccording mar-0">
                    <div className="df align-items-center justify-content-between margin-top-10">
                        <button
                            className="btn reportBtn"
                            onClick={updateSettings}
                            disabled={!saveEnabled}
                        >
                            Save
                        </button>
                    </div>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Pay Codes</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EarningCodes
                                mappedEarningCodes={mappedEarningCodes}
                                onTypeChange={changeEarningCode}

                            ></EarningCodes>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Report Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ReportSettings
                                useRetro={useRetro}
                                combineEins={combineEins}
                                onValueChange={onValueChange}
                                NPSRateTableId={NPSRateTableId}
                                GenRateTableId={GenRateTableId}
                                BillingRateTableId={BillingRateTableId}
                                compHistoryReportId={compHistoryReportId}
                                tableTemplate={tableTemplate}
                            ></ReportSettings>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Employer Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EmployerSettings
                                employerEmail={employerEmail}
                                employerPhone={employerPhone}
                                signerName={signerName}
                                signerTitle={signerTitle}
                                employerName={employerName}
                                employerAddress={employerAddress}
                                contractorName={contractorName}
                                employerTaxId={employerTaxId}
                                onChange={onValueChange}></EmployerSettings>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Cost Center (Job) Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <CostCenter
                                costCenters={props.PARENT_COST_CENTERS}
                                costCenterTreeName={costCenterTreeName}
                                certifiedJobField={certifiedJobField}
                                buildingTypeField={buildingTypeField}
                                deductBenefitsField={deductBenefitsField}
                                contractRegistrationField={contractRegistrationField}
                                contractRegDefault={contractRegDefault}
                                onChange={onValueChange}></CostCenter>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className="titleAccording">Employee Settings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <EmployeeSettings
                                jourOrApprenField={jourOrApprenField}
                                tradeClassField={tradeClassField}
                                tradeClassSource={tradeClassSource}
                                jourOrApprenDefVal={jourOrApprenDefVal}
                                defTradeClass={defTradeClass}
                                onChange={onValueChange}></EmployeeSettings>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </AccordionDetails>
        </Accordion>
    )
};

const mapStateToProps = ({ UserReducer, ClientDataReducer, CertifiedPayrollReducer, EarningCodeReducer, CostCenterReducer }) => {

    let { PARENT_COST_CENTERS } = CostCenterReducer;

    return { UserReducer, ClientDataReducer, CertifiedPayrollReducer, EarningCodeReducer, PARENT_COST_CENTERS };
};

export default connect(mapStateToProps, {
    getCertifiedSettings,
    saveCertifiedSettings
})(CertifiedPayrollReportSettings);